import { Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { devicePaths } from './paths';

const { DevicesView } = lazyImport(() => import('../views/devices'), 'DevicesView');
const { DeviceDetailsView } = lazyImport(() => import('../views/deviceDetails'), 'DeviceDetailsView');
const { AlertDetailsView } = lazyImport(() => import('../../alerts/views/alertDetails'), 'AlertDetailsView');
const { AttackDetailsView } = lazyImport(() => import('../../attacks/views/attackDetails'), 'AttackDetailsView');
const { AnomaliesDetailsView } = lazyImport(() => import('../../anomalies/views'), 'AnomaliesDetailsView');

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const deviceRoutes: RouteObject[] = [
  {
    path: devicePaths.absolute,
    element: <Layout />,
    children: [
      { path: '', element: <DevicesView /> },
      {
        path: devicePaths.details.absolute,
        element: <DeviceDetailsView />,
      },
      { path: devicePaths.alertDetails.relative, element: <AlertDetailsView /> },
      { path: devicePaths.attackDetails.relative, element: <AttackDetailsView /> },
      { path: devicePaths.aiAnomaliesDetails.relative, element: <AnomaliesDetailsView /> },
    ],
  },
];
